import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { FacebookDeclinedPermissionsException } from 'services/auth'
import { loginWithFacebook } from 'services/auth/identities/facebook'
import { facebookSDKInitializedSelector } from 'services/external/selectors'
import { StoreThunkDispatch } from 'store/state'
import LoginButton from './LoginButton'
import styles from './LoginButton.pcss'

interface FBLoginButtonProps {
  reAuth?: boolean
  loginParams?: Partial<Record<string, string>>
  className?: string
  onClick?: () => void
  onError?: (error: Error) => void
}

export default function FBLoginButton(props: FBLoginButtonProps) {
  const { reAuth, loginParams, className, onClick, onError } = props
  const dispatch = useDispatch<StoreThunkDispatch>()
  const navigate = useNavigate()
  const intl = useIntl()
  const initialized = useSelector(facebookSDKInitializedSelector)

  const onLogin = useCallback(() => {
    if (onClick) {
      onClick()
    }

    const options = reAuth ? { auth_type: 'rerequest' } : {}

    return dispatch(loginWithFacebook(false, options, loginParams))
      .catch((error: Error) => {
        if (onError) {
          onError(error)
        }

        if (error instanceof FacebookDeclinedPermissionsException) {
          navigate('/login/declined', { replace: true })
        }
      })
  }, [dispatch, navigate, onClick, onError, reAuth, loginParams])

  return (
    <LoginButton
      text
      initialized={initialized}
      buttonClassName={styles.facebook}
      progressClassName={styles.progress}
      className={className}
      onLogin={onLogin}
      displayInitialized={intl.formatMessage({ id: 'login.login-with-fb' })}
    />
  )
}
